var map = {
	"./images/angular-js.png": 610,
	"./images/c-sharp.png": 611,
	"./images/cpp.png": 612,
	"./images/html-css.png": 613,
	"./images/java.png": 614,
	"./images/js.png": 615,
	"./images/levels/c-sharp-beginner.png": 1452,
	"./images/levels/c-sharp-expert.png": 1453,
	"./images/levels/c-sharp-intermediate.png": 1454,
	"./images/levels/java-beginner.png": 1455,
	"./images/levels/java-expert.png": 1456,
	"./images/levels/java-intermediate.png": 1457,
	"./images/levels/js-beginner.png": 1458,
	"./images/levels/js-expert.png": 1459,
	"./images/levels/js-intermediate.png": 1460,
	"./images/levels/php-beginner.png": 1461,
	"./images/levels/php-expert.png": 1462,
	"./images/levels/php-intermediate.png": 1463,
	"./images/levels/python-beginner.png": 1464,
	"./images/levels/python-expert.png": 1465,
	"./images/levels/python-intermediate.png": 1466,
	"./images/levels/solidity-beginner.png": 1467,
	"./images/levels/solidity-expert.png": 1468,
	"./images/levels/solidity-intermediate.png": 1469,
	"./images/node-js.png": 616,
	"./images/php.png": 617,
	"./images/python.png": 618,
	"./images/react-js.png": 619,
	"./images/solidity.png": 620,
	"./images/tech-writing.png": 621,
	"./images/vue-js.png": 622
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1451;


//////////////////
// WEBPACK FOOTER
// ./src/resources/validations ^.*\.png$
// module id = 1451
// module chunks = 146